import { AnimatePresence, motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { getUser } from "../../services/user-service";

const menuAnimation = {
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0,
    // transition: { duration: 0.3, when: "afterChildren" },
    transition: {
      duration: 0.35,
      ease: "easeInOut",
      when: "afterChildren",
    },
  },
  show: {
    opacity: 1,
    height: "auto",
    transition: {
      // duration: 0.3,
      duration: 0.1,
      ease: "easeInOut",
      when: "beforeChildren",
      staggerChildren: 0.04,
    },
  },
};
const menuItemAnimation = {
  hidden: (i) => ({
    padding: 0, 
    x: "-100%",
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
  show: (i) => ({
    x: 0,
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
};

// const SidebarMenu = ({ route, showAnimation, isOpen, setIsOpen }) => {
   const SidebarMenu = ({ route, showAnimation, isOpen, setIsOpen, basePath }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let role = getUser().role.toLowerCase();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsOpen(true);
  };

  useEffect(() => {
    if (!isOpen) {
      setIsMenuOpen(false);
    }
  }, [isOpen]);
  return (
    <>
    <div >
      <div className="menu" onClick={toggleMenu}>
        <div className="menu_item">
          <div className="icon">{route.icon}</div>
          <AnimatePresence>
            {isOpen && (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="link_text"
              >
                {route.name}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {isOpen && (
          <motion.div
            animate={
              isMenuOpen
                ? {
                    rotate: 0,
                  }
                : { rotate: -90 }
            }
          >
            <FaAngleDown />
          </motion.div>
        )}
      </div>{" "}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            variants={menuAnimation}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="menu_container"
          >
            {route.subRoutes.map((subRoute, i) => (
              <motion.div variants={menuItemAnimation} key={i} custom={i}>
{/*                 <NavLink to={"/"+role+subRoute.path} className="link"> */}
                  <NavLink to={basePath + subRoute.path} className="link">
                  <div className="icon">{subRoute.icon}</div>
                  <motion.div className="link_text">{subRoute.name}</motion.div>
                </NavLink>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      </div>
    </>
  );
};

export default SidebarMenu;